import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardSettingServiceUX = (props: any) => {
    return(
      <div
        id="CardSettingServiceUX-div-0"
        style={{padding: "15px"}}>
        <div
          id="CardSettingServiceUX-div-1"
          style={{fontSize: "1.7rem", color: "rgb(79, 79, 79)", fontWeight: "bold", marginBottom: "1.5rem", marginTop: "-0.25rem", }}>
          ตั้งค่าสำหรับเปิดขายรายการบริการ
        </div>
        <div
          className="ui form"
          id="CardSettingServiceUX-div-2">
          
          <Form
            id="CardSettingServiceUX-Form-3">
            <FormGroup
              id="CardSettingServiceUX-FormGroup-4"
              style={{display: "flex", alignItems: "flex-end"}}>
              <FormField
                id="CardSettingServiceUX-FormField-5"
                style={{display: "block"}}
                width="3">
                <label
                  id="CardSettingServiceUX-label-14">
                  
                </label>
                <Input
                  icon="search"
                  id="CardSettingServiceUX-Input-15"
                  name="code"
                  onChange={(e, { value }) => props.onChangeData("code", value)}
                  placeholder="ค้นหาด้วยรหัสบริการ"
                  value={props.code}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingServiceUX-FormField-6"
                style={{display: "block"}}
                width="6">
                <label
                  id="CardSettingServiceUX-label-13">
                  
                </label>
                <Input
                  icon="search"
                  id="CardSettingServiceUX-Input-16"
                  name="name"
                  onChange={(e, { value }) => props.onChangeData("name", value)}
                  placeholder="ค้นหาด้วยชื่อบริการ"
                  value={props.name}>
                </Input>
              </FormField>
              <FormField
                id="CardSettingServiceUX-FormField-7"
                style={{display: "block", lineHeight: "0"}}
                width="3">
                <label
                  id="CardSettingServiceUX-label-12"
                  style={{ lineHeight: "16px" }}>
                  สถานะการเปิดขาย
                </label>
                <Dropdown
                  id="CardSettingServiceUX-Dropdown-17"
                  name="active_flag"
                  onChange={(e, { value }) => props.onChangeData("active_flag", value)}
                  options={props.serviceStatusOption}
                  selection={true}
                  value={props.activeFlag}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardSettingServiceUX-FormField-8"
                style={{display: "block"}}>
                <label
                  id="CardSettingServiceUX-label-11">
                  
                </label>
                <div
                  id="CardSettingServiceUX-div-19">
                  {props.buttonSearch}
                </div>
              </FormField>
              <FormField
                id="CardSettingServiceUX-FormField-9"
                style={{display: "block"}}>
                <label
                  id="CardSettingServiceUX-label-10">
                  
                </label>
                <div
                  id="CardSettingServiceUX-div-18">
                  {props.buttonAddNewService}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardSettingServiceUX-div-20">
          
          <Table
            data={props.serviceData}
            defaultPageSize={10}
            headers="รหัสบริการ,ชื่อบริการ,ชื่อบริการภาษาอังกฤษ,ประเภทบริการ,ราคาขาย,วันที่เริ่มต้น,วันที่สิ้นสุด,สถานะการเปิดขาย,Actions"
            id="CardSettingServiceUX-Table-21"
            keys="serviceCode,name,name_en,productType,servicePrice,startDate,endDate,serviceStatus,action"
            minRows="10"
            pageSize={10}
            showPagination={false}
            style={{height: "calc(70vh - 1.5rem)"}}
            widths="150,200,200,150,130,130,130,140,150">
          </Table>
        </div>
        <div
          id="CardSettingServiceUX-div-22"
          style={{display: "flex", justifyContent: "flex-end", padding: "5px"}}>
          
          <div
            id="CardSettingServiceUX-div-23">
            {props.pagination}
          </div>
        </div>
      </div>
    )
}


export default CardSettingServiceUX

export const screenPropsDefault = {}

/* Date Time : Wed Mar 04 2026 17:22:54 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ตั้งค่าสำหรับเปิดขายรายการบริการ"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.7rem\", color: \"rgb(79, 79, 79)\", fontWeight: \"bold\", marginBottom: \"1.5rem\", marginTop: \"-0.25rem\", }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Form",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-Form-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-FormGroup-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"flex-end\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-FormField-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-FormField-6"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        },
        "width": {
          "type": "value",
          "value": "6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-FormField-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\", lineHeight: \"0\"}"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-FormField-8"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-FormField-9"
        },
        "style": {
          "type": "code",
          "value": "{display: \"block\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-label-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "label",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-label-11"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะการเปิดขาย"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-label-12"
        },
        "style": {
          "type": "code",
          "value": "{ lineHeight: \"16px\" }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-label-13"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-label-14"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Input",
      "parent": 5,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-Input-15"
        },
        "name": {
          "type": "value",
          "value": "code"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onChangeData(\"code\", value)"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาด้วยรหัสบริการ"
        },
        "value": {
          "type": "code",
          "value": "props.code"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Input",
      "parent": 6,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-Input-16"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onChangeData(\"name\", value)"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาด้วยชื่อบริการ"
        },
        "value": {
          "type": "code",
          "value": "props.name"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Dropdown",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-Dropdown-17"
        },
        "name": {
          "type": "value",
          "value": "active_flag"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onChangeData(\"active_flag\", value)"
        },
        "options": {
          "type": "code",
          "value": "props.serviceStatusOption"
        },
        "placeholder": {
          "type": "code",
          "value": ""
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.activeFlag"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonAddNewService"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 21,
      "name": "Table",
      "parent": 20,
      "props": {
        "data": {
          "type": "code",
          "value": "props.serviceData"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "10"
        },
        "headers": {
          "type": "value",
          "value": "รหัสบริการ,ชื่อบริการ,ชื่อบริการภาษาอังกฤษ,ประเภทบริการ,ราคาขาย,วันที่เริ่มต้น,วันที่สิ้นสุด,สถานะการเปิดขาย,Actions"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-Table-21"
        },
        "keys": {
          "type": "value",
          "value": "serviceCode,name,name_en,productType,servicePrice,startDate,endDate,serviceStatus,action"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "pageSize": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"calc(70vh - 1.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "150,200,200,150,130,130,130,140,150"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", padding: \"5px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardSettingServiceUX-div-23"
        }
      },
      "seq": 23,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "name": "CardSettingServiceUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
